/* eslint-disable no-param-reassign */

// Cria promessa
function createPromise(config) {
  config.lastPromise = new Promise(
    // Só preciso do resolvedor, ela sempre será resolvida ao fim do timer.
    (resolver) => {
      config.lastPromiseResolver = resolver;
    },
  )
    // Quando for resolvida, chame e retorne a função em cadeia.
    .then(() => config.fn(...config.lastParams));
}

// Resolve a promessa, finalizando o delay.
const resolvePromise = (config) => {
  // Limpe tudo, não haverá mais nada pendente.
  clearTimeout(config.lastTimer);
  config.lastTimer = null;
  config.lastPromise = null;
  const tempResolver = config.lastPromiseResolver;
  config.lastPromiseResolver = null;
  // Acione a promessa para finalmente executar o código.
  tempResolver();
};

// Aciona o timer
function touchTimer(config) {
  // Se houver um timer ativo, limpe-o;
  if (config.lastTimer !== null) {
    clearTimeout(config.lastTimer);
  }

  // Cria um novo timer para resolver a promessa, renovando o delay.
  config.lastTimer = setTimeout(() => resolvePromise(config), 1000);
}

// Quando for chamado...
function onDelayedCalled(config, params) {
  // Sempre mantém apenas o último parametro informado.
  config.lastParams = params;

  // Se não houver promessa pendente, crie uma.
  // Se já houver promessa, manter a mesma, pois já pode haver algo esperando ela.
  if (config.lastPromise === null) {
    createPromise(config);
  }

  // Atualize o timer.
  touchTimer(config);

  // Retorna a promessa pendente.
  return config.lastPromise;
}

// eslint-disable-next-line import/prefer-default-export
export function delayed(fn) {
  const config = {
    lastTimer: null,
    lastParams: null,
    lastPromise: null,
    lastPromiseResolver: null,
    fn,
  };

  return (...params) => onDelayedCalled(config, params);
}
